import { Text } from 'Components/Text/Text';

import styles from './UnsavedChangesWarning.module.css';

interface UnsavedChangesWarningProps {
    hasUnsavedChanges: boolean;
}

/** Shows/hides itself depending on whether a form has unsaved changes. Intended to be used in conjunction with `useUnsavedChangesTracking`. */
export const UnsavedChangesWarning = (props: UnsavedChangesWarningProps) => {
    if (!props.hasUnsavedChanges) {
        return <></>;
    }

    return (
        <div className={styles.warningTextContainer}>
            <Text color="red">There are unsaved changes.</Text>
        </div>
    );
};
